function outOfBounds(r,c,rows,cols){
  return r < 0 || r >= rows || c < 0 || c >= cols;
}

export default function getPlateCoords(row,col,geometry,length,direction){

  let { rows, cols }  = geometry;

  let directions = {
    right:[0,1],
    left:[0,-1],
    up:[-1,0],
    down:[1,0]
  }

  let path = [];
  let loci = [row,col];
  let d = directions[direction];
  for(let ii = 0; ii < length; ii++){

    if( outOfBounds( loci[0], loci[1], rows, cols ) ){
      break;
    }

    path.push(loci);



    let [nr,nc] = [ loci[0] + d[0], loci[1] + d[1] ];

    if( nr >= rows ){ // we're going down
      nr = 0;
      nc++;
    }

    if( nr < 0 ){ // we're going up
      nr = rows - 1;
      nc--;
    }

    if( nc >= cols ){ // we're going right
      nr++;
      nc = 0;
    }

    if( nc < 0 ){ // going to the left
      nr--;
      nc = cols - 1;
    }

    loci = [nr,nc];

  }


  return path;


}


